export default "__VITE_ASSET__DDZaBHea__"